import NotAuthorized from '../NotAuthorized/NotAuthorized'
import Startseite from '../Dashboard/Startseite'
import Verordnung from '../Verordnung/Verordnung'
import VerordnungEdit from '../VerordnungEdit/VerordnungEdit'
import VerordnungDetail from '../VerordnungDetail/VerordnungDetail'
import Onboarding from '../Onboarding/Onboarding'
import Verteilnetzbetreiber from '../Verteilnetzbetreiber/Verteilnetzbetreiber'
import VNBDetail from '../VNBDetail/VNBDetail'
import Geschaeftspartner from '../Geschaeftspartner/Geschaeftspartner'
import GPDetail from '../GPDetail/GPDetail'
import GPVerfuegungSetup from '../Dashboard/GP/GPVerfuegungSetup'
import VerfuegungNeu from "../Verfuegung/VerfuegungNeu";
import VerfuegungPendent from "../Verfuegung/VerfuegungPendent";
import GPImport from '../GPImport/GPImport'
import VNBDashboardOffeneEinladungen from "../Dashboard/VNB/VNBDashboardOffeneEinladungen";
import VerordnungMonitoring from "../VerordnungMonitoring/VerordnungMonitoring";
import KontingentMonitoring from "../KontingentMonitoring/KontingentMonitoring";
import {ZVV} from "../ZVV/ZVV";
import VNBImport from '../VNBImport/VNBImport'
import PeriodeMonitoring from '../PeriodeMonitoring/PeriodeMonitoring'

export default class Navigation {

  static get NAVIGATION_HAPPEND() {
    return 'eko-frontend-navigation-happened'
  }

  static get ROUTES() {
    return {
      notAuthorized: {url: 'NotAuthorized', component: NotAuthorized},
      dashboard: {url: 'Dashboard', component: Startseite},
      onboarding: {url: 'Onboarding', component: Onboarding},
      gpVerfuegungSetup: {url: 'GPVerfuegungSetup', component: GPVerfuegungSetup},
      geschaeftspartner: {url: 'Geschaeftspartner', component: Geschaeftspartner},
      gpStammdaten: {url: 'GPStammdaten', component: GPDetail},
      gpVerbrauchsstaette: {url: 'GPVerbrauchsstaette', component: GPDetail},
      gpBenutzer: {url: 'GPBenutzer', component: GPDetail},
      gpZVV: {url: 'GPZVV', component: GPDetail},
      gpImport: {url: 'GPImport', component: GPImport},
      monitoringVerordnung: {url: 'Kontingentierung', component: VerordnungMonitoring},
      monitoringKontingent: {url: 'Kontingent', component: KontingentMonitoring},
      kontingentWeitergabe: {url: 'KontingentWeitergabe', component: KontingentMonitoring},
      monitoringPeriodeVnb: {url: 'VNBPeriode', component: PeriodeMonitoring},
      monitoringVerbrauch: {url: 'VerbrauchMonitoring', component: VerordnungMonitoring},
      verteilnetzbetreiber: {url: 'Verteilnetzbetreiber', component: Verteilnetzbetreiber},
      vnbStammdaten: {url: 'VNBStammdaten', component: VNBDetail},
      vnbBenutzer: {url: 'VNBBenutzer', component: VNBDetail},
      vnbDashboardOffeneEinladungen: {url: 'vnbDashboardOffeneEinladungen', component: VNBDashboardOffeneEinladungen},
      vnbImport: {url: 'VNBImport', component: VNBImport},
      verordnung: {url: 'Verordnung', component: Verordnung},
      verordnungCreate: {url: 'VerordnungCreate', component: VerordnungEdit},
      verordnungEdit: {url: 'VerordnungEdit', component: VerordnungEdit},
      verordnungDetail: {url: 'VerordnungDetail', component: VerordnungDetail},
      verfuegungNeu: {url: 'VerfuegungNeu', component: VerfuegungNeu},
      verfuegungPendent: {url: 'VerfuegungPendent', component: VerfuegungPendent},
      zvvStammdaten: {url: 'ZVVStammdaten', component: ZVV},
      zvvMitglieder: {url: 'ZVVMitglieder', component: ZVV},
    }
  }

  static getComponent(url) {
    const routes = this.ROUTES
    return routes[Object.keys(routes).filter(key => routes[key].url === url)].component
  }

  constructor() {
    window.onhashchange = _ => window.send(Navigation.NAVIGATION_HAPPEND, getNavigationHash())
  }
}
const navigation = new Navigation()
